import React from "react";
import { useTranslation } from "react-i18next";
import { PaginationItem } from "./utils";

interface PaginationProps {
    currentPage: number;
    pageSize: number;
    pageSizes: readonly number[];
    paginationItems: PaginationItem[];
    totalPages: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (pageSize: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    currentPage,
    pageSize,
    pageSizes,
    paginationItems,
    totalPages,
    onPageChange,
    onPageSizeChange,
}) => {
    const { t } = useTranslation();

    return (
        <div className="file-manager-pagination system-text mt-4 d-flex flex-column flex-md-row align-items-center justify-content-md-between gap-3">
            <select
                className="form-select form-select-sm border-0 shadow-none w-auto system-text"
                value={pageSize}
                onChange={event => onPageSizeChange(Number(event.target.value))}
                aria-label={t("settings.Files per page")}
            >
                {pageSizes.map(size => (
                    <option key={size} value={size}>
                        {t("settings.filesPerPage", { count: size })}
                    </option>
                ))}
            </select>

            <div className="d-flex align-items-center gap-1">
                <button
                    type="button"
                    className={`border-0 rounded-1 bg-transparent ${currentPage === 1 ? "text-border-gray" : "text-dark-gray"}`}
                    onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                    disabled={currentPage === 1}
                    aria-label={t("settings.Previous page")}
                >
                    <i className="bi bi-chevron-left" aria-hidden="true"></i>
                </button>
                {paginationItems.map(item => typeof item === "number" ? (
                    <button
                        key={item}
                        type="button"
                        className={`border-0 rounded-1 ${item === currentPage ? "bg-blue text-white" : "bg-transparent text-dark-gray"}`}
                        onClick={() => onPageChange(item)}
                    >
                        {item}
                    </button>
                ) : (
                    <span key={item} className="px-1" aria-hidden="true">
                        <i className="bi bi-three-dots"></i>
                    </span>
                ))}
                <button
                    type="button"
                    className={`border-0 rounded-1 bg-transparent ${currentPage === totalPages ? "text-border-gray" : "text-dark-gray"}`}
                    onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                    disabled={currentPage === totalPages}
                    aria-label={t("settings.Next page")}
                >
                    <i className="bi bi-chevron-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    );
};

export default Pagination;
